import React, { useState } from "react";
import {
    Box,
    Dialog,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";

import Mensagem from "../../Components/Mensagem";
import { ButtonBase, FormSectionTitle } from "../Pedidos/styles";
import { baixarClientesSemCodigoSisdm } from "./clientesSemCodigoSisdm";
import { formatarMoeda } from "./utils";

const ModalInconsistencias = ({ show, onHide, onContinuar, periodo, itens = [] }) => {
    const [mensagem, setMensagem] = useState('');
    const [baixando, setBaixando] = useState(false);

    async function handleBaixarExcel() {
        setBaixando(true);
        try {
            await baixarClientesSemCodigoSisdm(periodo);
        } catch (e) {
            setMensagem('Erro ao gerar a planilha de exportação.');
        } finally {
            setBaixando(false);
        }
    }

    return (
        <Dialog open={show} onClose={onHide} maxWidth="md" fullWidth PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}>
            {mensagem && (
                <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant="danger" />
            )}
            <Box sx={{
                backgroundColor: 'white',
                py: 3,
                px: 4,
                my: 3,
                borderRadius: '30px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                width: '100%',
                position: 'relative',
                boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
            }}>
                <FormSectionTitle label="Inconsistências Encontradas" />

                <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                    {itens.length} faturamento(s) têm campos obrigatórios não preenchidos e serão
                    ignorados na integração.
                </Typography>

                <TableContainer sx={{ maxHeight: 320, width: '100%' }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Cliente</TableCell>
                                <TableCell>Produto</TableCell>
                                <TableCell>NS</TableCell>
                                <TableCell align="right">Valor</TableCell>
                                <TableCell>Problema</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {itens.map((item) => (
                                <TableRow key={item.faturamentoId}>
                                    <TableCell>{item.clienteNome || item.distribuidorNome || "—"}</TableCell>
                                    <TableCell>{item.produto || "—"}</TableCell>
                                    <TableCell>{item.numeroSerie || "—"}</TableCell>
                                    <TableCell align="right">{formatarMoeda(item.valorParcela)}</TableCell>
                                    <TableCell>{(item.inconsistencias || []).join("; ")}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', gap: 2, mt: 3, width: '100%', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <ButtonBase variant="outlined" onClick={handleBaixarExcel} disabled={baixando}>
                        Baixar Lista Excel
                    </ButtonBase>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        {onContinuar && (
                            <ButtonBase variant="contained" onClick={onContinuar}>
                                Continuar
                            </ButtonBase>
                        )}
                        <ButtonBase variant="outlined" onClick={onHide}>
                            Fechar
                        </ButtonBase>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
};

export default ModalInconsistencias;
